module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "80%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "scrollable": "",
      "persistent": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n      " + _vm._s(_vm.nachricht.message.subject) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteMail(_vm.nachricht.id)
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), (_vm.nachricht.status) ? _c('v-chip', {
    attrs: {
      "label": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.nachricht.status))]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "pa-2"
  }, [(_vm.nachricht.datum) ? _c('div', {
    staticClass: "subtitle-2"
  }, [_vm._v("\n        " + _vm._s(_vm.$filters.date(_vm.nachricht.datum, "DD.MM.YYYY hh:mm")) + " Uhr\n      ")]) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-2 pa-2"
  }, [_vm._v("\n      Von:\n      "), (_vm.nachricht.absender.position) ? _c('span', [_vm._v(_vm._s(_vm.nachricht.absender.position))]) : _vm._e(), _vm._v(" "), (_vm.nachricht.absender.name) ? _c('span', [_vm._v(_vm._s(_vm.nachricht.absender.name))]) : _vm._e(), _vm._v(" "), (_vm.nachricht.von) ? _c('span', [_vm._v(_vm._s(_vm.$filters.user(_vm.nachricht.von, _vm.bbrbbr)))]) : _vm._e(), _vm._v(" "), (_vm.nachricht.an) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n        An:\n        "), _vm._l((_vm.nachricht.gruppen), function(item2, index2) {
    return _c('v-chip', {
      key: index2 * 2,
      staticClass: "mr-1",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("group")])], 1), _vm._v("\n          " + _vm._s(item2) + "\n        ")], 1)
  }), _vm._v(" "), _vm._l((_vm.nachricht.an), function(item, index) {
    return _c('v-chip', {
      key: index * 2 + 1,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n          " + _vm._s(_vm.$filters.user(item, _vm.bbrbbr)) + "\n        ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_cc) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n        CC:\n        "), _vm._l((_vm.nachricht.an_cc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n          " + _vm._s(_vm.$filters.user(item, _vm.bbrbbr)) + "\n        ")], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nachricht.an_bcc) ? _c('div', {
    staticClass: "mt-1"
  }, [_vm._v("\n        BCC:\n        "), _vm._l((_vm.nachricht.an_bcc), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "mr-1",
      attrs: {
        "pill": "",
        "small": ""
      }
    }, [_c('v-avatar', {
      attrs: {
        "left": ""
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n          " + _vm._s(_vm.$filters.user(item, _vm.bbrbbr)) + "\n        ")], 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-sheet', {
    staticStyle: {
      "overflow-y": "scroll"
    },
    attrs: {
      "max-height": "calc(100vh - 404px)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.nachricht.message.html)
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ac2c3dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/dialogMail.vue
// module id = 747
// module chunks = 15